import { UserOutlined } from '@ant-design/icons'
import {
  Avatar,
  Space,
  TableColumnsType,
  Typography,
} from 'antd'
import React, { useMemo } from 'react'

import { NormalStatus } from '@/constants/normal-status'
import { Creator } from '@/model/creator'

import CreatorOperations from '../components/creator-operations'

const { Text } = Typography

export interface Record extends Creator {
  employeeNames: string
  groupIds: number[]
}

export default function useCreatorColumns(
  openUpdateFormModal: (creator: Record) => void,
): TableColumnsType<Record> {
  return useMemo(() => [{
    title: 'Creators',
    dataIndex: 'name',
    width: 140,
    render: (name, { avatarUrl }) => (
      <Space>
        <Avatar icon={<UserOutlined />} shape="circle" src={avatarUrl} />
        <Text ellipsis>{name}</Text>
      </Space>
    ),
  }, {
    title: 'bio',
    dataIndex: 'bio',
    width: 180,
    render: (bio: Record['bio']) => bio || '-',
  }, {
    title: 'Status',
    dataIndex: 'status',
    width: 130,
    render: (status: Record['status']) =>
      <Text type={status === NormalStatus.Activated ? 'success' : 'danger'}>{status}</Text>,
  }, {
    title: 'Operations',
    key: 'operations',
    width: 160,
    render: (_, creator) => (
      <CreatorOperations
        creator={creator}
        openUpdateFormModal={openUpdateFormModal}
      />
    ),
  }], [openUpdateFormModal])
}
